module.exports = __webpack_public_path__ + "static/media/petEmptyAvatar.308debef.png";